import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { isOwnerPanelUser } from "@/lib/ownerAccess";

export const RequireAuth = ({ children }) => {
  const { user, booting } = useAuth();
  const loc = useLocation();
  if (booting) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  return children;
};

export const RequireApproved = ({ children }) => {
  const { user, booting } = useAuth();
  if (booting) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "owner" && user.status !== "approved")
    return <Navigate to="/pending" replace />;
  return children;
};

export const RequireOwner = ({ children }) => {
  const { user, booting } = useAuth();
  if (booting) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (!isOwnerPanelUser(user)) return <Navigate to="/" replace />;
  return children;
};

const FullScreenLoader = () => (
  <div className="min-h-screen grid place-items-center bg-[#fff7f0]">
    <div className="flex items-center gap-3 text-[#5c534d]">
      <Loader2 className="animate-spin text-[#ff6a00]" size={22} />
      <span className="font-medium">Loading…</span>
    </div>
  </div>
);
